import { render, staticRenderFns } from "./AllocateErrorRecord.vue?vue&type=template&id=20c0ea24&scoped=true&lang=pug&"
import script from "./AllocateErrorRecord.vue?vue&type=script&lang=ts&"
export * from "./AllocateErrorRecord.vue?vue&type=script&lang=ts&"
import style0 from "./AllocateErrorRecord.vue?vue&type=style&index=0&id=20c0ea24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c0ea24",
  null
  
)

export default component.exports